import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73b4327d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ibf-text-body1 hint-build-cache" }, "Must be 1GB to 10,000GB", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_incredi_input_num_with_menu = _resolveComponent("incredi-input-num-with-menu")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_action_menu_portal_container = _resolveComponent("action-menu-portal-container")!

  return (_openBlock(), _createBlock(_component_action_menu_portal_container, {
    title: "Build Cache Folder Size",
    disable: !_ctx.cacheSizeValid || _ctx.buildCacheSettings?.cacheSizeGB === _ctx.cacheSizeGB,
    "data-testid": _ctx.elementIds.agents.contextMenu.buildCacheConfiguration.cacheSize,
    onSubmit: _ctx.onSubmit,
    onKeyup: _withKeys(_ctx.onSubmit, ["enter"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_form, {
        onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"]),
        ref: "acfl--form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_incredi_input_num_with_menu, {
            value: _ctx.cacheSizeGB,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cacheSizeGB) = $event)),
            "input-width": 160,
            "default-option": "GB",
            mask: "######",
            "menu-min-width": "53",
            "lazy-rules": "",
            class: "row hover-shadow cache-input",
            "no-error-icon": "",
            "menu-options": ['GB'],
            "id-name": "agent-resize-cache",
            "data-testid": "build-cache-folder-size-input",
            onInputChange: _cache[1] || (_cache[1] = 
          (value) => {
            _ctx.cacheSizeGB = parseInt(value);
          }
        )
          }, null, 8, ["value"]),
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }, 8, ["disable", "data-testid", "onSubmit", "onKeyup"]))
}